import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EventsListFilterData,
  EventsListGridResponse,
} from '../../../models/events/eventsAdminGridResponse';
import * as moment from 'moment';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { EventTags } from '../../../models/events/AnyoEvents';

export interface CheckboxOptions {
  label: string;
  value: string;
  checked: boolean;
}

export interface DateFilterEmitData {
  dates: Date[] | undefined;
  options: string[];
}

@Component({
  selector: 'app-events-table',
  templateUrl: './events-table.component.html',
  styleUrl: './events-table.component.scss',
})
export class EventsTableComponent {
  @Input() eventsTableData: EventsListGridResponse | undefined;
  @Output() resetFilterEvent = new EventEmitter<void>();
  @Output() pageSizeChangeEvent = new EventEmitter<number>();
  @Output() pageChangeEvent = new EventEmitter<number>();
  @Output() categoryFilterEvent = new EventEmitter<string[]>();
  @Output() paymentTypeFilterEvent = new EventEmitter<string[]>();
  @Output() eventsDateFilterEvent = new EventEmitter<DateFilterEmitData>();
  @Output() hideTestFilterEvent = new EventEmitter<boolean>();
  @Output() activeFilterEvent = new EventEmitter<string[]>();
  @Output() searchEvent = new EventEmitter<string>();
  public eventTags = EventTags;
  dateFormat = 'dd/MM/yyyy';
  categoryCheckBoxOptions: CheckboxOptions[] = [];
  paymentTypeCheckBoxOptions: CheckboxOptions[] = [];
  dateCheckBoxOptions: CheckboxOptions[] = [
    {
      label: 'Event Date',
      value: 'eventDate',
      checked: false,
    },
    {
      label: 'Registration Cut Off Date',
      value: 'registrationCutOffDate',
      checked: false,
    },
    {
      label: 'Visible From',
      value: 'visibleFrom',
      checked: false,
    },
  ];
  pageSizeOptions = [10, 20, 50, 100];
  selectedCategoryString: string[] = [];
  selectedPaymentTypeString: string[] = [];
  selectedActiveString: string[] = [];
  hideTestEvent: boolean = false;
  globalSearchInput = '';
  activeCheckBoxOptions: CheckboxOptions[] = [
    { label: 'Active', value: 'true', checked: false },
    { label: 'Inactive', value: 'false', checked: false },
  ];

  eventsColumnFilterDate: Date[] | undefined;

  disabledDate = (current: Date) => {
    return moment(current).isBefore(moment('01/12/2023', 'dd/MM/YYYY'));
  };

  openEventRegistration(id: string) {
    window.open(`/events/registrations?eventId=${id}`, '_blank');
  }

  searchGlobal() {
    if (this.globalSearchInput.trim().length) {
      this.searchEvent.emit(this.globalSearchInput.trim());
    }
  }

  resetSearch() {
    this.globalSearchInput = '';
  }

  resetValues() {
    this.categoryCheckBoxOptions = [];
    this.paymentTypeCheckBoxOptions = [];
    this.selectedCategoryString = [];
    this.selectedPaymentTypeString = [];
    this.selectedActiveString = [];
    this.eventsColumnFilterDate = undefined;
    this.dateFilter = [];
    this.activeCheckBoxOptions = this.activeCheckBoxOptions.map(opt => ({ ...opt, checked: false }));
    this.dateCheckBoxOptions = this.dateCheckBoxOptions.map(opt => ({ ...opt, checked: false }));
  }

  resetFilter() {
    this.resetFilterEvent.emit();
  }

  nzPageIndexChange(page: number) {
    this.pageChangeEvent.emit(page);
  }

  nzPageSizeChange(pageSize: number) {
    this.pageSizeChangeEvent.emit(pageSize);
  }

  categoryFilterFn() {
    this.categoryFilterEvent.emit(this.selectedCategoryString);
  }

  categoryFilterChangeFn($event: string[]) {
    this.selectedCategoryString = $event;
  }

  setCategoryFilterData(filterOptions?: EventsListFilterData) {
    if (this.categoryCheckBoxOptions.length === 0 && filterOptions?.category) {
      this.categoryCheckBoxOptions = filterOptions.category.map((data) => ({
        checked: this.selectedCategoryString.includes(data.categoryId),
        label: data.categoryName,
        value: data.categoryId,
      }));
    } else if (this.categoryCheckBoxOptions.length > 0) {
      this.categoryCheckBoxOptions.forEach((opt) => {
        opt.checked = this.selectedCategoryString.includes(opt.value);
      });
    }
  }

  paymentTypeFilterFn() {
    this.paymentTypeFilterEvent.emit(this.selectedPaymentTypeString);
  }

  paymentTypeFilterChangeFn($event: string[]) {
    this.selectedPaymentTypeString = $event;
  }

  activeFilterFn() {
    this.activeFilterEvent.emit(this.selectedActiveString);
  }

  activeFilterChangeFn($event: string[]) {
    this.selectedActiveString = $event;
  }

  setPaymentTypeFilterData(filterOptions?: EventsListFilterData) {
    if (this.paymentTypeCheckBoxOptions.length === 0 && filterOptions?.paymentTypes) {
      this.paymentTypeCheckBoxOptions = filterOptions.paymentTypes.map((data) => ({
        checked: this.selectedPaymentTypeString.includes(data),
        label: this.utils.convertToTitleCase(data),
        value: data,
      }));
    } else if (this.paymentTypeCheckBoxOptions.length > 0) {
      this.paymentTypeCheckBoxOptions.forEach((opt) => {
        opt.checked = this.selectedPaymentTypeString.includes(opt.value);
      });
    }
  }

  dateFilterFn() {
    const data: DateFilterEmitData = {
      dates: this.eventsColumnFilterDate,
      options: this.dateFilter,
    };
    this.eventsDateFilterEvent.emit(data);
  }

  dateFilter!: string[];

  dateFilterChangeFn($event: string[]) {
    this.dateFilter = $event;
  }

  onEventsFilterDateChange($event: Date[]) {
    this.eventsColumnFilterDate = $event;
  }

  testEventChangeFn($event: boolean) {
    this.hideTestEvent = $event;
    this.hideTestFilterEvent.emit($event);
  }

  constructor(public utils: UtilsService) { }
}
